import React from 'react';
import { createRoot } from 'react-dom/client';

import { Main } from './main';

const container = document.getElementById('app');
if (!container) throw new Error('Root container #app not found');
const root = createRoot(container);
root.render(<Main />);
